import request from '@/utils/request'


// 新 - 获取用户信息
export const userInfo = ()=> {
  return request({
    url: '/app-api/member/user/get',
    method: "get"
  })
}


// 获取用户信息
// export const userInfo = ()=> {
//   return request({
//     url: '/admin-api/client/pc/user/get',
//     method: "get"
//   })
// }

// 修改用用户信息
// export const updateUser = (data)=> {
//   return request({
//     url: '/admin-api/client/pc/user/update',
//     method: "put",
//     data: data
//   })
// }


export const updateUser = (data)=> {
  return request({
    url: '/app-api/member/user/update',
    method: "put",
    data: data
  })
}

// 上传用户头像
export const uploadUserImg = (file) => {
  // 创建 FormData 对象，用于存放文件数据
  const formData = new FormData();
  formData.append('avatarFile', file);
  return request({
    url: '/admin-api/client/pc/user/update-avatar',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',  // 设置内容类型为 multipart/form-data
    },
    data: formData,  // 将 FormData 作为请求体发送
  });
};


// 新 - 修改用户密码 /app-api/member/user/update-password
export const updateUserPassword = (data)=>{
  return request({
    url: '/app-api/member/user/update-password',
    method: 'put',
    data: data
  })
}


// 修改用户密码
// export const updateUserPassword = (data)=>{
//   return request({
//     url: '/admin-api/client/pc/user/update-password',
//     method: 'put',
//     data: data
//   })
// }

// 校验手机验证码
export const validateSms = (data)=>{
  return request({
    url: '/app-api/member/auth/validate-sms-code',
    method: 'post',
    data: data
  })
}


// 发送手机验证码
export const sendSms = (data)=>{
  return request({
    url: '/app-api/member/auth/send-sms-code',
    method: 'post',
    data: data
  })
}


// 创建会员api凭证 {name: '',appId: '',userId: '',}
export const creteaAicredentials = (data)=>{
  return request({
    url: '/admin-api/client/pc/apicredentials/create',
    method: 'post',
    data: data
  })
}

// 删除api凭证  {id: ''}
export const deleteApicredentials = (params)=>{
  return request({
    url: '/admin-api/client/pc/apicredentials/delete',
    method: 'get',
    params: params
  })
}

// 启用或停用api凭证  {id:'',appId}
export const enableOrDisable = (params)=>{
  return request({
    url: '/admin-api/client/pc/apicredentials/enable-or-disable',
    method: 'get',
    params: params
  })
}

// 获得会员api凭证 {id:''}
export const apiList = (params)=>{
  return request({
    url: '/admin-api/client/pc/apicredentials/get',
    method: 'get',
    params: params
  })
}

// 分页获得会员api凭证
export const pageApiList = (params)=>{
  return request({
    url: '/admin-api/client/pc/apicredentials/page',
    method: 'get',
    params: params
  })
}

// 修改手机号 /app-api/member/user/update-mobile

export const updateMobile  = (data)=>{
  return request({
    url: '/app-api/member/user/update-mobile',
    method: 'put',
    data: data
  })
}














